export const TAG_COLORS = ['purple', 'red', 'green', 'grey'] as const
